import React, {useEffect} from 'react';
import {Link, Paper, Stack, Typography} from '@mui/material';
import ExcerptList from './ExcerptList';

export function conflictAnchorId(conflictId) {
    return conflictId ? `coverage-conflict-${conflictId}` : '';
}

function ConflictCard({conflict, active, onNavigateToQuestion, onOpenReport}) {
    const titleClickable = Boolean(conflict.questionId);
    return (
        <Paper
            id={conflictAnchorId(conflict.id)}
            variant="outlined"
            sx={{
                p: 1.5,
                borderColor: active ? 'primary.main' : undefined,
                bgcolor: active ? 'action.hover' : undefined,
            }}
        >
            <Stack spacing={1}>
                {titleClickable ? (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => onNavigateToQuestion?.(conflict.questionId)}
                        sx={{fontWeight: 700, textAlign: 'left', color: 'text.primary',
                            '&:hover': {color: 'primary.main'}}}
                    >
                        {conflict.title}
                    </Link>
                ) : (
                    <Typography variant="body2" fontWeight={700}>
                        {conflict.title}
                    </Typography>
                )}
                {conflict.summary && (
                    <Typography variant="caption" color="text.secondary">
                        {conflict.summary}
                    </Typography>
                )}
                <ExcerptList excerpts={conflict.excerpts} onOpenReport={onOpenReport}/>
            </Stack>
        </Paper>
    );
}

/**
 * Conflicts tab: flat C1 conflict list. AR/question-linked conflicts have a
 * clickable title navigating to the Questions tab with that question active;
 * theme conflicts (no anchors) have a plain title. Excerpts open the FINTEL.
 */
export default function AnalyticConflictsTab({
    view,
    activeConflictId = null,
    onNavigateToQuestion,
    onOpenReport,
}) {
    useEffect(() => {
        if (!activeConflictId) {
            return undefined;
        }
        const timer = setTimeout(() => {
            document.getElementById(conflictAnchorId(activeConflictId))
                ?.scrollIntoView({behavior: 'smooth', block: 'start'});
        }, 100);
        return () => clearTimeout(timer);
    }, [activeConflictId]);

    if (!view?.conflicts?.length) {
        return (
            <Typography variant="body2" color="text.secondary">
                No conflicts detected across related FINTELs.
            </Typography>
        );
    }

    return (
        <Stack spacing={1.5}>
            {view.conflicts.map((conflict) => (
                <ConflictCard
                    key={conflict.id}
                    conflict={conflict}
                    active={activeConflictId != null && conflict.id === activeConflictId}
                    onNavigateToQuestion={onNavigateToQuestion}
                    onOpenReport={onOpenReport}
                />
            ))}
        </Stack>
    );
}
